import { Field, Form, Formik } from "formik";
import { ScrollToFirstError } from "utils";
import { Button, Textarea, Checkbox } from "shared";
import { Input } from "shared";
import { InvestmentItem } from "../../../types";
import { CryptoValues } from "./types";
import { cryptoSchema } from "./validationSchemas";
import { RELIANCE_CONSENT_TRANSACTIONS_LABEL } from "./constants";

interface CryptoFormProps {
  item: InvestmentItem;
  onSubmit: (values: CryptoValues) => void;
  onCancel: () => void;
  isPending: boolean;
  isAdmin?: boolean;
}

const CryptoForm = ({
  item,
  onSubmit,
  onCancel,
  isPending,
  isAdmin = false,
}: CryptoFormProps) => {
  const isReliance = item.origin === "reliance";
  const hideAdditionalInfo = !isAdmin && isReliance;
  const hideRelianceCanView = isAdmin && isReliance;
  const initialValues: CryptoValues = {
    name: item.name ?? "",
    currencyUuid: (item as any).currency?.uuid ?? "",
    additionalInfo: item.additionalInfo ?? "",
    relianceCanView: item.relianceCanView ?? false,
    status: item.status ?? "active",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={cryptoSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {(formik) => (
        <Form>
          <ScrollToFirstError />
          <div className="modal-form__fields">
            <Field
              as={Input}
              name="name"
              label="Nazwa"
              type="text"
              error={
                (formik.touched.name || formik.submitCount > 0) &&
                formik.errors.name
                  ? formik.errors.name
                  : undefined
              }
            />

            {!hideAdditionalInfo && (
              <Field
                component={Textarea}
                name="additionalInfo"
                label="Dodatkowe informacje"
                optional
              />
            )}

            {!hideRelianceCanView && (
              <>
                <Field
                  component={Textarea}
                  name="additionalInfo"
                  label="Dodatkowe informacje"
                  optional
                />
                {!isAdmin && (
                  <Field
                    as={Checkbox}
                    name="relianceCanView"
                    label={RELIANCE_CONSENT_TRANSACTIONS_LABEL}
                    checked={formik.values.relianceCanView}
                    onChange={() =>
                      formik.setFieldValue(
                        "relianceCanView",
                        !formik.values.relianceCanView,
                      )
                    }
                  />
                )}
              </>
            )}
          </div>

          <div className="modal-buttons">
            <Button
              type="button"
              className="button--stroke button--rounded"
              onClick={onCancel}
              label="Anuluj"
            />
            <Button
              type="submit"
              className="button--black button--rounded"
              onClick={() => {}}
              label={isPending ? "Zapisywanie..." : "Zapisz"}
              isLoading={isPending}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CryptoForm;
